import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, apiErrorMessage } from "../lib/api";
import { ShieldCheck, Users } from "lucide-react";

export default function PublicStreamer() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get(`/public/streamers/${slug}`)
      .then((r) => setData(r.data))
      .catch((e) => setErr(apiErrorMessage(e, "Profile not found")));
  }, [slug]);

  useEffect(() => {
    if (data?.publicNoIndex) {
      const m = document.createElement("meta");
      m.name = "robots"; m.content = "noindex, nofollow";
      document.head.appendChild(m);
      return () => { document.head.removeChild(m); };
    }
  }, [data]);

  if (err) return <div className="max-w-3xl mx-auto px-6 py-24 text-[#8B97AE]" data-testid="public-streamer-error">{err}</div>;
  if (!data) return <div className="max-w-3xl mx-auto px-6 py-24 text-[#8B97AE]" data-testid="public-streamer-loading">Loading…</div>;

  return (
    <div className="max-w-4xl mx-auto px-6 py-16 lg:py-20">
      <div className="font-mono text-[11px] uppercase tracking-widest text-[#2DD4A7] mb-3">Verified streamer</div>
      <div className="flex items-center gap-3 mb-6">
        <h1 className="font-display text-4xl sm:text-6xl font-black tracking-tighter" data-testid="public-streamer-name">{data.displayName}</h1>
        <span className="inline-flex items-center gap-1.5 border border-emerald-500/50 text-emerald-400 px-3 py-1.5 text-xs font-mono uppercase tracking-widest" data-testid="public-streamer-badge">
          <ShieldCheck className="w-3.5 h-3.5" /> Verified
        </span>
      </div>
      <p className="text-[#8B97AE] text-sm mb-10">Verified since {(data.verifiedAt || "").slice(0, 10) || "—"}</p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
        <div className="border border-white/15 p-6">
          <div className="flex items-center gap-2 mb-4"><Users className="w-4 h-4 text-[#2DD4A7]" /><h2 className="font-display font-bold">Verified players</h2></div>
          <div className="font-display text-5xl font-black" data-testid="public-players-count">
            {data.verifiedPlayersMasked ? "<10" : (data.verifiedPlayersCount ?? "0")}
          </div>
          <p className="text-xs text-[#8B97AE] mt-2">Aggregate figure only — no individual data.</p>
        </div>
        <div className="border border-white/15 p-6">
          <h2 className="font-display font-bold mb-4">Active affiliate codes</h2>
          {data.affiliateCodes?.length ? (
            <ul className="space-y-2" data-testid="public-codes-list">
              {data.affiliateCodes.map((c, i) => (
                <li key={i} className="flex items-center justify-between border border-white/10 px-3 py-2 text-sm">
                  <span className="text-[#8B97AE]">{c.casino}</span>
                  <span className="font-mono text-white">{c.code}</span>
                </li>
              ))}
            </ul>
          ) : (
            <div className="text-sm text-[#8B97AE]">No public codes yet.</div>
          )}
        </div>
      </div>

      <p className="text-xs text-[#5A6478] font-mono">18/21+ · Play only within regulations of your jurisdiction.</p>
    </div>
  );
}
